
import React, {useState, useEffect, useContext, useRef} from "react";
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { UserLoginContext } from "../../context/UserLoginContext";
import { authenticatedFetch } from "../../services/authService";

const WaiversTable = () => {
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [data, setData] = React.useState([]);
    const [waivers, setWaivers] = React.useState([]);
    const [selectedWaiver, setSelectedWaiver] = React.useState(null);
    const [submissionCounts, setSubmissionCounts] = React.useState({});


    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    // Update table data whenever waivers change
    useEffect(() => {
        if (userState.status && waivers) {
            const tableData = waivers.map((waiver, i) => {
                // Get submission count for this waiver
                const submissionCount = submissionCounts[waiver._id] || 0;

                return {
                    id: waiver._id,
                    Title: waiver.Title,
                    Description: waiver.Description || "",
                    Submissions: submissionCount,
                    Version: waiver.Version || "1.0",
                    Enabled: waiver.Enabled ? "Yes" : "No",
                    CreatedAt: waiver.createdAt ? new Date(waiver.createdAt).toLocaleDateString() : "",

                    actions: (
                        <div className="actions-right">
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"add_" + i}>Add New Waiver</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        let tURL = "/admin/addwaiver";
                                        await history.push(tURL);
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-add"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"preview_" + i}>Preview Form</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setSelectedWaiver(waiver);
                                        let tURL = "/admin/previewwaiver/" + waiver._id;
                                        await history.push(tURL);
                                    }}
                                    color="primary"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-notes"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Waiver</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setSelectedWaiver(waiver);
                                        let tURL = "/admin/editwaiver/" + waiver._id;
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"view_" + i}>View Submissions</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setSelectedWaiver(waiver);
                                        let tURL = "/admin/waiversubmissions/" + waiver._id;
                                        await history.push(tURL);
                                    }}
                                    color="success"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-zoom-split"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Waiver</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        var theWaivers = [...waivers];
                                        theWaivers.find((o, idx) => {
                                            if (o._id === waiver._id) {
                                                _deleteWaiverAlert(o._id, theWaivers, idx);
                                                return true;
                                            }
                                            return false;
                                        });
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [waivers, userState.status, submissionCounts]);

    useEffect(() => {
        const getWaivers = async () => {
            const waiversList = await authenticatedFetch(rest.waivers, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            });
            const waiversData = await waiversList.json();
            setWaivers(waiversData);

            // Fetch submission counts for each waiver
            const counts = {};
            for (const waiver of waiversData) {
                try {
                    const submissionsResponse = await authenticatedFetch(`${rest.waiversubmissions}/${waiver._id}`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json;charset=UTF-8'
                        }
                    });
                    const submissions = await submissionsResponse.json();
                    counts[waiver._id] = Array.isArray(submissions) ? submissions.length : 0;
                } catch (error) {
                    console.error(`Error fetching submissions for waiver ${waiver._id}:`, error);
                    counts[waiver._id] = 0;
                }
            }
            setSubmissionCounts(counts);
        };

        getWaivers();
    }, [dataLoaded]);

    const fetchWaivers = async () => {
        const waiversList = await authenticatedFetch(rest.waivers, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        });
        const waiversResponse = await waiversList;
        const waiversData = await waiversResponse.json();
        return(waiversData);
    };

    const _delete_waiver = async (id) => {
        let tempURL = rest.waivers + '/' + id;
        const waiversList = await authenticatedFetch(tempURL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        });
        const waiversResponse = await waiversList;
        const waiversData = await waiversResponse.json();
    };

    const _deleteWaiverAlert = async (id, waivers, index) => {
        setalert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Yes, delete it!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure?"
                style={{display: "block"}}
                onConfirm={async () => {
                    waivers.splice(index, 1);
                    setWaivers(waivers);
                    await _delete_waiver(id);
                    setalert(null);
                    notify("success", "Waiver has been deleted successfully!");
                    setDataLoaded(!dataLoaded);
                }}
                onCancel={() =>  {
                    setalert(null);
                }}
            >
                Are you sure you want to delete this waiver? This will not delete any submissions that have already been made.
            </SweetAlert>
        );
    };

    if (userState.status) {
        return (
            <>
                <div className="rna-container">
                    <NotificationAlert ref={notificationAlertRef} />
                </div>
                <div className="content">
                    <Col md={8} className="ml-auto mr-auto">
                        <h2 className="text-center">Manage Waivers</h2>
                        <p className="text-center">
                            Create and manage waiver templates that can be filled out and submitted by participants
                        </p>
                    </Col>
                    <Row className="mt-5">
                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <CardTitle tag="h4">Waivers</CardTitle>
                                        </Col>
                                        <Col md="6" className="text-right">
                                            <Button
                                                color="info"
                                                onClick={() => history.push("/admin/addwaiver")}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-simple-add"/> Add Waiver
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Description",
                                                accessor: "Description"
                                            },
                                            {
                                                Header: "Submissions",
                                                accessor: "Submissions",
                                                maxWidth: 120
                                            },
                                            {
                                                Header: "Version",
                                                accessor: "Version",
                                                maxWidth: 100
                                            },
                                            {
                                                Header: "Enabled",
                                                accessor: "Enabled",
                                                maxWidth: 100
                                            },
                                            {
                                                Header: "Created",
                                                accessor: "CreatedAt"
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {alert}
                </div>
            </>

        );
    }

    else {
        history.push("/admin/dashboard");
        return(null);
    }
};

export default WaiversTable;
